import React from 'react'
import PropTypes from "prop-types";


function NoticeBar({text}) {
  return (
        <div className='content'>
         <h2>NOTICE!</h2>
         <p>{text}
         </p>
        </div>
  )
}

NoticeBar.propTypes = {
	text: PropTypes.string,
};

export default NoticeBar